import { Grid } from "@mui/material";
import { DateField, Labeled, TextField } from "react-admin";

const CourseInfo = () => (
  <Grid
    container
    spacing={3}
  >
    <Grid
      item
      xs={12}
      md={3}
    >
      <Labeled label="Име">
        <TextField
          source="name"
          emptyText="—"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={3}
    >
      <Labeled label="Секция">
        <TextField
          source="section"
          emptyText="—"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={3}
    >
      <Labeled label="ID в Google">
        <TextField
          source="googleCourseId"
          emptyText="—"
        />
      </Labeled>
    </Grid>
    <Grid
      item
      xs={12}
      md={3}
    >
      <Labeled label="Създаден на">
        <DateField
          source="createdAt"
          showTime
          emptyText="—"
          locales="bg-BG"
        />
      </Labeled>
    </Grid>
  </Grid>
);

export default CourseInfo;
